export default "__VITE_ASSET__a3efbfc2__"